"use strict";

import React, { Component } from "react";
import {Form, loader, ValueManager, PropTypes} from "Subschema";
import consumerUi from "consumersignupnodeweb-ui";
import "./app.less";
import "../less/captcha.lessp";
import fraudnet from '../lib/fraudnet.js';

import {requestTracking, pageInfo} from "../PropTypes";


loader.addLoader(consumerUi);

// this flag is used to check if the pa.js file has already been
// added to head tag or not.
let initFptiComplete= false;

function initFptiTracking() {

    if (initFptiComplete) {
         return;
    }

    initFptiComplete = true;

    const head = document.getElementsByTagName("head")[0];
    const paScript = document.createElement("script");

    paScript.async = true;
    paScript.type = "text/javascript";
    paScript.src = "//www.paypalobjects.com/pa/js/pa.js";

    head.appendChild(paScript);

}

function setupFptiTracking(requestTrackingData) {

    let timeoutId;

    clearTimeout(timeoutId);

    if (window.PAYPAL && typeof window.PAYPAL.analytics !== 'undefined') {

        window.PAYPAL.core = window.PAYPAL.core || {};

        if (requestTrackingData && requestTrackingData.dataString && requestTrackingData.url) {
            window.PAYPAL.core.pta = PAYPAL.analytics.setup({
                data:requestTrackingData.dataString,
                url:requestTrackingData.url
            });
        } else {
            window.PAYPAL.core.pta = PAYPAL.analytics.setup();
        }

    } else {

         timeoutId = setTimeout(setupFptiTracking.bind(null, requestTrackingData), 250);

    }
}

export default class App extends Component {
    /**
     * @param props
     * @param rest
     */
    static childContextTypes = {
        "onSubmit": PropTypes.func,
        requestTracking,
        pageInfo,
        tagData: PropTypes.object,
        maskedInoutUnsupported: React.PropTypes.bool,
        isAndroid: React.PropTypes.bool
    };

    static propTypes = {
        fetch: PropTypes.oneOfType([PropTypes.shape({post: PropTypes.func}), PropTypes.func]),
        requestTracking,
        unknownErrorMessage: PropTypes.object
    };

    static defaultProps = {
        unknownErrorMessage: {"global.error": [{ "message": "Unknown Error Occurred, Please try again" }]}
    };

    getChildContext() {
        return {
            "onSubmit": this.handleSubmit,
            requestTracking: this.requestTracking,
            pageInfo: this.pageInfoData,
            tagData: this.tagData,
            maskedInoutUnsupported: this.props.deviceInfo && this.props.deviceInfo.maskedInoutUnsupported,
            isAndroid: this.props.deviceInfo && this.props.deviceInfo.isAndroid
        };
    }

    processTrackingObj = (sys) => {

        var trackingObj = {};

        if (sys && sys.tracking && sys.tracking.fpti) {
            if (sys.tracking.fpti.dataString) {

                var reqDataString = {},
                i,
                parts,
                pairs = sys.tracking.fpti.dataString.split('&'),
                updatedDataString = "";

                for (i = 0; i < pairs.length; i++) {
                    parts = pairs[i].split('=');
                    reqDataString[parts[0]] = decodeURIComponent(parts[1]);
                }

                Object.keys(reqDataString).map(function(value, index) {
                    if (value !== "page" && value !== "pgrp" && value !== "tmpl") {
                        updatedDataString += "" + value + "=" + reqDataString[value] +"&";
                    }
                });

                trackingObj.dataString = updatedDataString.slice(0,-1);
            }

            if (sys.tracking.fpti.serverURL) {
                trackingObj.url = sys.tracking.fpti.serverURL;
            }
        }

        this.requestTracking = Object.assign((this.requestTracking || {}), trackingObj);
    };

    constructor(props, ...rest) {
        super(props, ...rest);
        const {currentPageSchema, sys, viewErrors, viewData={}, _csrf, history, viewId, tagData, ...state} = props;

        this.state = {
          currentPageSchema
        };

        viewData._csrf = _csrf;
        if (!viewData._internal) {
            viewData._internal = {};
        }
        viewData._internal.viewId = this.viewId = viewId || '';
        this.valueManager = ValueManager(viewData, viewErrors);
        this.valueManager.addSubmitListener(null, this.handleSubmit, this, false);
        this.history = history;

        this.tagData = tagData;
        this.processTrackingObj(sys);

        if (typeof document !== "undefined" && typeof window !== "undefined") {
            // initialize FPTI tracking
            initFptiTracking();

            // set up FPTI tracking
            setupFptiTracking(this.requestTracking);
        }
        this.oneTouchInjected = false;
    }

    handleBackButton = (viewId) => {
        this.valueManager.update('_internal.busy', true);
        return this.handleResponse(this.props.fetch.get(`/signup/api/get/${viewId}?force_consumersignup=1`), false);
    };

    addBackButtonHook = (history) => {
        if (history && history.listenBefore) {
            this.unlistenBackButton = history.listenBefore((location, callback) => {
                if (location && location.action && location.action === 'POP') {
                    this.handleBackButton(location.pathname).then(callback());
                } else {
                    callback(true);
                }
            });
        }
    }

    componentWillMount() {
        const {
          currentPageSchema,
          sys
        } = this.props;


        this.addBackButtonHook(this.history);
        this.pageInfoData = this.populatePageInfoData(currentPageSchema, sys);
    }

    componentWillUnMount() {
        if (typeof this.unlistenBackButton === 'function') {
            this.unlistenBackButton();
            this.unlistenBackButton = null;
        }
    }

    componentWillReceiveProps(props, context) {
        this.valueManager.setValue(props.viewData);
        this.valueManager.setErrors(props.viewErrors);
        this.requestTracking = context.requestTracking;
    }

    handleResponse = (p, updateHistory)=> {
        return p.then((response) => {
            this.injectOneTouch(response);
            const {currentPageSchema, sys, viewData, viewId, viewErrors, _csrf, bankAuthUrl,
                fraudNetData, tagData} = response.data || response;

            if (bankAuthUrl &&
                typeof window !== 'undefined' &&
                typeof window.location !== 'undefined') {
                window.location = bankAuthUrl;
            }
            if (!viewData) {
                this.valueManager.update('_csrf', _csrf);
            } else {
                viewData._csrf = _csrf;
                if (!viewData._internal) {
                    viewData._internal = {};
                }
                viewData._internal.viewId = viewId || '';
                this.valueManager.setValue(viewData);
            }
            this.valueManager.setErrors(viewErrors);

            if (updateHistory && this.history && viewId) {
                if (!this.viewId || this.viewId !== viewId) {
                    this.history.push({pathname: viewId ? `/${viewId}` : '', search: '?force_consumersignup=1'})
                }
            }
            this.viewId = viewId;
            this.tagData = tagData;
            this.processTrackingObj(sys);

            if (currentPageSchema) {
                this.pageInfoData = this.populatePageInfoData(currentPageSchema, sys);
                if(this.valueManager && Array.isArray(this.valueManager.validateListeners)) {
                    this.valueManager.removeListener(...this.valueManager.validateListeners);
                }
                this.setState({currentPageSchema});
            }
            this.valueManager.update('_internal.busy', false);
            fraudnet.init(fraudNetData);
        }, (error)=> {
            this.valueManager.update('_internal.busy', false);
            this.valueManager.setErrors(this.props.unknownErrorMessage);
            this.forceUpdate();
        });
    }

    handleSubmit = (e, err, value)=> {
        e && e.preventDefault();
        if (err && Object.keys(err).length > 0) {
            return false;
        }
        this.valueManager.update('_internal.busy', true);
        this.handleResponse(this.props.fetch.post(`/signup/api/submit/${this.viewId}?force_consumersignup=1`, value), true);
        return false;
    };

    populatePageInfoData({ fieldsets } = {}, { pageInfo } = {}) {
      let fptiPgrp = "";
      const {
        hostName,
        rlogId
      } = pageInfo || {}

      if (fieldsets && fieldsets.length) {
        for (let i = 0; i<fieldsets.length; i++) {
          if(fieldsets[i].template === "FptiTemplate") {
            fptiPgrp = fieldsets[i].pgrp;
            break;
          }
        }
      }
      return {
        hostName,
        rlogId,
        fptiPgrp
      }
    }

    injectOneTouch = (response) => {
        const oneTouchOptInFlag = response && response.data && response.data.oneTouchOptInFlag || false;
        const isLoggedIn = response && response.data && response.data.isLoggedIn || false;
        if(typeof window != 'undefined') {
            if(oneTouchOptInFlag === true && isLoggedIn === true && !this.oneTouchInjected && window.PAYPAL && window.PAYPAL.unifiedLogin) {
                this.oneTouchInjected = true;
                window.PAYPAL.unifiedLogin.base = '/signup/js';
                window.PAYPAL.unifiedLogin.inject({
                    targetElement: document.getElementById('injectedUnifiedLogin'),
                    iframePathname: '/signin/activate-one-touch?flowName=consumerOnBoarding',
                    onPostMessage: function(response) {
                        var postMessageEl = document.getElementById('postMessage');
                        postMessageEl.innerHTML = JSON.stringify(response);
                    }
                });
            }
        }
    }

    render() {
        return (
            <Form
              schema={this.state.currentPageSchema}
              valueManager={this.valueManager}
              loader={loader}
              template="ObjectTemplate"/>
            );
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/App.jsx
 **/